<template>
  <b-overlay :show="companyLoading" class="rounded" variant="transparent">
    <template #overlay>
      <b-img
        width="100"
        :src="require('@/assets/img/brand/loader.gif')"
        alt=""
      />
    </template>
    <div class="card shadow p-3 rounded">
      <div class="card-header border-0 bg-transparent">
        <base-title :title="title" popover="Listado de empresas disponibles para administrar por el usuario en sesión">
          <template slot="button">
            <b-button
              size="sm"
              variant="primary"
              @click="$router.push({ name: 'create_company' })"
              >{{ $t("add") }}</b-button
            >
          </template>
        </base-title>
    
      </div>

      <b-row>
        <b-col md="2" sm="12">
          <b-form-select
            v-model="filter.per_page"
            :options="[5, 10, 20, 100]"
            @input="debouncedGetAnswer()"
            size="sm"
            class="mt-2 content-dark"
          ></b-form-select>
        </b-col>
        <b-col class="ml-auto col-sm-12 col-md-6 col-lg-3 mb-3">
          <b-form-group>
            <b-input-group>
              <b-form-input
                debounce="900"
                class="form-control-sm"
                type="search"
                v-model="filter.search"
                :placeholder="$t('search')"
                @input="debouncedGetAnswer()"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="12" class="table-responsive">
          <b-table
            class="align-items-center table-flush tablesorter table-text"
            hover
            :items="getCompany.data"
            :fields="columns"
            :per-page="filter.per_page"
            :current-page="filter.current_page"
          >
            <template v-slot:cell(actions)="data">
              <b-button
                v-b-tooltip.hover
                :title="$t('show')"
                variant="info"
                size="sm"
                @click="
                  $router.push({
                    name: 'show_company',
                    params: { id: data.item.id },
                  })
                "
                ><i class="far fa-eye"></i
              ></b-button>
              <b-button
                v-b-tooltip.hover
                :title="$t('edit')"
                variant="warning"
                size="sm"
                @click="
                  $router.push({
                    name: 'edit_company',
                    params: { id: data.item.id },
                  })
                "
                ><i class="far fa-edit"></i
              ></b-button>
              <b-button
                v-b-tooltip.hover
                :title="$t('delete')"
                variant="danger"
                size="sm"
                @click="deleteCompany(data.item.id)"
                ><i class="far fa-trash-alt"></i
              ></b-button>
            </template>
          </b-table>
          <b-pagination
            class="mt-3"
            v-model="filter.page"
            :total-rows="getCompany.total"
            :per-page="getCompany.per_page"
            :page-count="getCompany.per_page"
            @input="changePage"
            first-number
            pills
            size="sm"
            align="center"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-overlay>
</template>
      <script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import _ from "lodash";
export default {
  name: "companies-table",
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  async created() {
    this.debouncedGetAnswer = _.debounce(this.getData, 200);
    await this.getData();
  },
  data() {
    return {
      filter: {
        page: 1,
        per_page: 5,
        search: null,
        paginated: true,
      },
    };
  },
  methods: {
    ...mapActions({
      fetchCompany: "fetchCompany",
      delCompany: "deleteCompany",
    }),
    async getData() {
      await this.fetchCompany(this.filter);
    },
    async changePage(value) {
      this.filter.page = value;
      await this.debouncedGetAnswer();
    },
    async deleteCompany(id) {
      await Swal.fire({
        title: this.$t("are_you_sure?"),
        text: this.$t("question_delete_company"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#172b4d",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("not"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await this.delCompany(id);
            if (res.status === 200)
              this.$toast.success(res.message, {
                position: "top-right",
              });
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      getCompany: "getCompany",
      companyLoading: "companyLoading",
    }),
    columns() {
      return [
        { label: this.$t("name"), key: "name", class: "text-center" },
        { label: this.$t("phone"), key: "phone", class: "text-center" },
        { label: this.$t("email"), key: "email", class: "text-center" },
        {
          label: this.$t("country"),
          key: "city.country.name",
          class: "text-center",
        },
        { label: this.$t("actions"), key: "actions", class: "text-center" },
      ];
    },
  },
};
</script>